export default __webpack_public_path__ + "static/4-881db410a21ae212314f305009a41907.png";